import { useTranslation } from "react-i18next";
import { FileUp } from "lucide-react";
import { ExamAttachmentsUpload } from "@/components/medical-records/ExamAttachmentsUpload";
import { ExamGallery, type AttachmentRow } from "@/components/medical-records/ExamGallery";
import type { ExamAttachmentUpload } from "@/hooks/useExamAttachments";
import { mobileSurfaceClass } from "./mobile-surface";

interface MobileDocumentsTabProps {
  clinicId?: string | null;
  attachments: AttachmentRow[];
  isLoading?: boolean;
  onUpload?: (items: ExamAttachmentUpload[]) => Promise<void>;
  onDelete?: (attachment: AttachmentRow) => Promise<void>;
  onUpdate?: (payload: {
    attachmentId: string;
    name?: string | null;
    type: string;
    description: string | null;
    examDate: string | null;
    occurredAt?: string | null;
  }) => Promise<void>;
  readOnly: boolean;
}

export function MobileDocumentsTab({
  clinicId,
  attachments,
  isLoading,
  onUpload,
  onDelete,
  onUpdate,
  readOnly,
}: MobileDocumentsTabProps) {
  const { t } = useTranslation("medicalRecords");
  const canUpload = Boolean(clinicId && onUpload && !readOnly);

  return (
    <div className="space-y-4">
      {canUpload ? (
        <section className={mobileSurfaceClass}>
          <div className="mb-3 flex items-center gap-2">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary text-primary">
              <FileUp className="h-5 w-5" />
            </span>
            <div>
              <h2 className="font-heading text-base font-bold">{t("tabs.exams")}</h2>
              <p className="text-xs text-muted-foreground">{t("mobile.documents.description")}</p>
            </div>
          </div>
          <ExamAttachmentsUpload clinicId={clinicId!} onUpload={onUpload!} />
        </section>
      ) : null}
      <section className={mobileSurfaceClass}>
        <ExamGallery
          attachments={attachments}
          isLoading={isLoading}
          onDelete={readOnly ? undefined : onDelete}
          onUpdate={readOnly ? undefined : onUpdate}
          readOnly={readOnly}
        />
      </section>
    </div>
  );
}
